const { createReduxStore, register } = wp.data;

const STORE_NAME = "rbt/tabpanels-ui";

const store = createReduxStore(STORE_NAME, {
  reducer(state = {}, action) {
    switch (action.type) {
      case "SET_ACTIVE_TAB":
        return { ...state, [action.parentClientId]: action.tabid };
      default:
        return state;
    }
  },
  actions: {
    setActiveTab(parentClientId, tabid) {
      return { type: "SET_ACTIVE_TAB", parentClientId, tabid };
    },
  },
  selectors: {
    getActiveTab(state, parentClientId) {
      return state[parentClientId];
    },
  },
});

register(store);
export default STORE_NAME;
